import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const getProfileApi = createAsyncThunk('profile', async () => {
    const response = await axiosInstance.get('/getProfile');
    return response.data;
});

const profileSlice = createSlice({
    name: "profile",
    initialState: {
        data: [],
        errors: [],
        loading: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getProfileApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(getProfileApi.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(getProfileApi.rejected, (state, action) => {
                state.errors.push(action.error.message);
                state.loading = false;
            });
    }
});

export default profileSlice.reducer;
